// import wikiImg from '../../image/wikipediaExternalPage.png'
import {iTalksData, iLinkObj} from './interfaces'
import {LINKTYPES} from '../types'
import { LinkObj } from './sidebarPageManager'

const docsUrls:{[index: string]:string} = {
  'meet-greg': 'https://docs.google.com/presentation/d/131LsqmtjWthE9jwR64Lc4LrzB8PzOH9X/edit?usp=sharing&ouid=115465118347015352110&rtpof=true&sd=true',
  'react': 'https://docs.google.com/presentation/d/1aTG3O4FCbOfFRXmx6UC5uTfhfIc1m0Ok/edit?usp=sharing&ouid=115465118347015352110&rtpof=true&sd=true',
  'unit-tests': 'https://docs.google.com/presentation/d/1MVbkRUYE5-Cod5PxJlxeAcGYvMVY9BLv/edit?usp=sharing&ouid=115465118347015352110&rtpof=true&sd=true',
  'agile': 'https://docs.google.com/presentation/d/0Bywa4RhvihA4bkRuTUlwbUJ2RFE/edit?usp=sharing&ouid=115465118347015352110&resourcekey=0-aVlQ7Lu7SsKfby8tIKj2xQ&rtpof=true&sd=true',
  'maven': 'https://docs.google.com/presentation/d/1fF1rWkwT1UE06BOp1tKpyRoPkvM1ILw23uiyGXcfQRM/edit?usp=sharing',
  'spring-jdbc': 'https://docs.google.com/presentation/d/0Bywa4RhvihA4eTNQaGlYRHg4T0k/edit?usp=sharing&ouid=115465118347015352110&resourcekey=0-36PfKpNTk0vcdqFLDmy88w&rtpof=true&sd=true'
}


export default class TalksManager {
  talksData: Array<iTalksData> // same as object[]?

  constructor () {
    this.talksData = []
  }

  load () {
    const data:Array<iTalksData> = [{ key: 'meet-greg', title: 'Meet Greg',
      url: docsUrls['meet-greg'],
      description: `This is a presentation I gave as an introduction to myself, and a showcase of work
        I was doing with Crocs Shoes at the time. (2020-12-07)`
    },
    { key: 'react', title:  'Get Ready to React',
      url: docsUrls['react'],
      description: `This is a presentation I gave to the engineering team at Crocs to introduce them 
        to React.  It covers the basics of React, including:  JSX, components, props, state, lifecycle 
        methods, and hooks. (2020-02-20)`
    },
    { key: 'unit-tests', title: 'Unit and Integration Tests',
      url: docsUrls['unit-tests'],
      description: `jUnit testing can encompass 'unit tests', which address isolated code modules, 
        and 'integration tests', which test how modules interact with external resources such as 
        databases, the network and a filesystem.  This was a talk I gave to the CareDiscovery project 
        developer team at Thomson-Reuters Healthcare & Sciences in Evanston, IL.  It was to help clarify 
        the differences between the two types of jUnit testing, and the manner in which they are run. 
        (2011-03-28)`
    },
    {
      key: 'agile',
      title: 'Development Infrastructures Changes to Support Agile Processes',
      url: docsUrls['agile'],
      description: `This presentation outlines steps that the CareDiscovery development team at 
        Thomson-Reuters Healthcare & Sciences (Evanston, IL) were taking to adopt agile processes.  
        Distribute Version Control Systems, Mercurial, Maven and Continuous Integration Systems are 
        covered. (2010-07-28)`
    },
    {
      key: 'maven',
      title: 'Upgrading Maven from Version 1 to 2',
      url: docsUrls['maven'],
      description: `This was a presentation to the CareDiscovery development team at Thomson-Reuters 
        Healthcare & Sciences following the conversion of all projects from Maven 1 to Maven 2.  
        Issues covered include:  repository layout changes, standardized project layouts and lifecycles, 
        the new plugin architecture, the coordinate system, public repositories, repository servers, 
        pom.xml, dependency scoping and resolution, and techniques for customizing builds. (2010-08-12)`
    },
    {
      key: 'sprint-jdbc',
      title: 'Introducing Spring JDBC',
      url: docsUrls['spring-jdbc'],
      description: `This is a brief introduction to Spring JDBC given to the CareDiscovery development 
        team at Thomson-Reuters Healthcare & Sciences as part of a series of discussions for considering 
        technologies to include in the next generation platform. (2011-04-22)`
    }]
    data.forEach((talk) => {
      this.addTalk(talk.key, talk.title, talk.url, talk.description)
    })
  }

  addTalk (key:string, title:string, url: string, description: string):void {
    this.talksData.push(new Talk(key, title, docsUrls[key], description))
  }

  // TO DO Has yet to be tested...noone calling it
  get (key:string):iTalksData|undefined {
    return this.talksData.find((talk) => talk.key === key)
  }

  // TO DO Has yet to be tested...no page is using a sidebar talks link yet
  toLinkObj (key: string):iLinkObj {
    const talkData: iTalksData|undefined = this.get(key)
    return new LinkObj(talkData!.key, talkData!.title, LINKTYPES.internal, `/talk/${talkData!.key}`)
  }

}

export class Talk {
  key:string
  title:string
  url: string
  description: string
  constructor (key:string, title:string, url:string, description: string) {
    this.key = key
    this.title = title
    this.url = url
    this.description = description
  }
}
